var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-letter-side-bar"},_vm._l((_vm.recordLetterList),function(letter){return _c('p',{key:letter,on:{"click":function($event){$event.stopPropagation();return _vm.clickLetter(letter)}}},[_vm._v(_vm._s(letter))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }